import { Component, Inject, ElementRef, Input, OnInit } from '@angular/core';
import { AsyncPipe, CommonModule, NgIf } from '@angular/common';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { SignupService } from '../services/signup.service';
import { SignupDataService } from '../services/signup-data.service';
import { WINDOW, WINDOW_PROVIDERS } from '@app/shared/services/window/window.service';
import { AdditionalDetailsService } from '../services/additional-details.service';
import { FormlyModule } from '@ngx-formly/core';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { ConnectSlideComponent } from '@app/blocks/ui/slide/slide.component';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable, Subject, firstValueFrom, takeUntil } from 'rxjs';
import { SlideCommonService } from '@app/application/common/slide-common.service';
import { DataService } from '@app/core/services/data.service';
import { formatFormErrors } from '@app/shared/formly/form-config';

@Component({
    selector: 'app-additional-details',
    providers: [
        WINDOW_PROVIDERS
    ],
    imports: [
        CommonModule,
        FormlyModule,
        ConnectSlideComponent,
        SpinnerComponent,
        AsyncPipe,
        NgIf
    ],
    templateUrl: './additional-details.component.html',
    styleUrl: './additional-details.component.scss'
})
export class AdditionalDetailsComponent implements OnInit {

    @Input() slideNumber: string | undefined;
    @Input() finalSlide: boolean = false;
    currentSlide = 'residents';
    errors: any = [];
    errorMessage: string = "";
    showFormErrors = false; //error summary
    applicationId: any;
    loading = true; // spinner
    formState = this.signupService.getFormState();
    showSubmit = false;
    submitting = false;
    isDisabled = false;

    form: FormGroup = new FormGroup({});
    fields: BehaviorSubject<any> = new BehaviorSubject([]);
    model: any = this.signupService.getAdditionalDetailsModel();
    subscription = this.signupService.subscribeAdditionalDetailsModel((data: any) => {
        this.model = data;
    });

    active: any = {
        "active": "additionalDetails" // additionalDetails, nextOfKin, paymentMethod
    };

    private destroy$ = new Subject<void>();

    constructor(
        private logger: LoggerService,
        private signupService: SignupService,
        private signupDataService: SignupDataService,
        private dataService: DataService,
        private additionalDetailsService: AdditionalDetailsService,
        private slideCommon: SlideCommonService,
        private el: ElementRef,
        @Inject(WINDOW) private window: Window,) {
        this.active = this.signupService.getActive();
        this.model = this.signupService.getAdditionalDetailsModel();
        this.applicationId = sessionStorage.getItem('connect.applicationId');
    }

    scrollToId(id: string) {
        this.slideCommon.scrollToId(id, this.el, this.window);
    }

    ngOnInit(): void {

        this.applicationId = sessionStorage.getItem('connect.applicationId');

        console.log("Signup > Additional Details component has loaded!");

        // prevents users accessing the additional details page without going via homepage
        if (this.applicationId === '' || this.applicationId === null) {
            this.logger.info('signup > no applicationId detected');
            const redirect = this.window.location.protocol + '//' + this.window.location.host + '/';

            this.window.location = redirect;

        } else {
            this.logger.info('signup > applicationId detected');
        }


        this.loading = true;

        firstValueFrom(this.dataService.getReferenceData()).then(refData => {
            this.signupService.setRefDataModel(refData);

            const observables: Observable<any>[] = [
                this.signupDataService.getAdditionalDetails(this.applicationId),
                this.additionalDetailsService.fetchSchema(refData)
            ];

            this.dataService.ready(observables).pipe(takeUntil(this.destroy$)).subscribe({
                next: ([ additionalDetailsModel, formConfig ]) => {

                    const model = additionalDetailsModel;
                    // model.applicationForm = 'ops';

                    if (model.applicationForm && model.applicationForm != this.formState.applicationForm) {
                        console.log("addition details setting application form to " + additionalDetailsModel.applicationForm);
                        this.formState.applicationForm = additionalDetailsModel.applicationForm;
                        this.signupService.setFormState(this.formState);
                    }

                    this.formState.applicationForm = model.applicationForm;
                    this.signupService.setAdditionalDetailsModel(model);

                    this.logger.info('getAdditionalDetails result', additionalDetailsModel);

                    this.fields.next([ formConfig ]);

                    this.slideCommon.scroll(this.active.active);

                    this.loading = false; // stop spinner
                    this.showSubmit = true;
                    this.showFormErrors = false;
                },
                error: () => {
                    this.logger.error('additional-details.component.js dataService error');
                    this.loading = false; // stop spinner
                    this.showFormErrors = true;
                    return null;
                }
            });
        });
    }

    onSubmit() {
        this.logger.info('additional details submit clicked');
        this.form.markAllAsTouched();

        if (this.form.valid) {
            console.log("VALID");
            this.errors = [];
            this.showFormErrors = false;

            this.isDisabled = true;
            this.submitting = true;

            //firstValueFrom will throw an error if the post response is 200 but null
            this.signupDataService.postAdditionalDetails(this.model).pipe(takeUntil(this.destroy$)).subscribe({
                next: () => {
                    this.formState.progress.additionalDetailsComplete = true;
                    this.signupService.goForward('additionalDetails');

                    this.signupService.setFormState(this.formState);
                    this.submitting = false;
                    this.isDisabled = false;

                    this.slideCommon.scroll(this.active.active);
                },
                error: (error: any) => {
                    this.isDisabled = false;
                    this.submitting = false;
                    this.logger.error(error);
                }
            })
        }
        else {
            console.log("INVALID", this.form.errors)
            const renderTime = 500;
            const revealTime = renderTime + 250;

            setTimeout(() => {
                this.errors = formatFormErrors(this.el, this.form);
                this.showFormErrors = true;
            }, renderTime);

            setTimeout(() => {
                this.scrollToId('additional-details-error-summary');
            }, revealTime);
        }
    }
}
